import { injectable } from 'inversify';
import { ROUTE_RATE_RATE_UPDATED, ROUTE_RATE_SETTINGD_LOADED } from '../../../Constants/AppConstants';
import { RouteRateDTO } from '../../../Domain/DTO/RouteRateDTO';
import { SettingsDTO } from '../../../Domain/DTO/SettingsDTO';
import { ERateChangeType } from '../../../Domain/Enum/ERateChangeType';
import { ERating } from '../../../Domain/Enum/ERating';
import { IActionPayloaded } from '../../../Infrastructure/Action/IAction';
import { EntityReducer } from '../BaseEntity/EntityReducer';
import { IBaseEntityProps } from '../BaseEntity/IBaseEntityProps';
import { RouteRateHelperProps } from './IHelperProps';

type IState = IBaseEntityProps<RouteRateDTO, RouteRateHelperProps>;

@injectable()
export class RouteRateReducer extends EntityReducer<RouteRateDTO, RouteRateHelperProps> {

    public Reduce(state: IState, action: IActionPayloaded<any>): IState {
        switch (action.type) {
            case ROUTE_RATE_SETTINGD_LOADED:
                return this.ReduceSettingsLoaded(state, action.Payload);
            case ROUTE_RATE_RATE_UPDATED:
                return this.ReduceRateUpdated(state, action.Payload);
            default:
                return state;
        }
    }

    private ReduceSettingsLoaded(state: IState, payload: SettingsDTO): IState {
        return super.EntityLoaded<SettingsDTO>(state, payload, x => x.Settings);
    }

    private ReduceRateUpdated(state: IState, payload: number): IState {
        const newState: IState = { ...state, DataDTO: { ...<any>state.DataDTO }, DataHelper: { ...<any>state.DataHelper } };

        newState.DataDTO.Rate = payload;
        newState.DataHelper.RateList = [
            {
                RateGroup: ERating.A,
                RateValue: this.CalculateRateForGroup(payload, state.DataHelper.Settings.RateChangeTypeForAGroup, state.DataHelper.Settings.RateChangeForAGroup)
            }, 
            {
                RateGroup: ERating.B, 
                RateValue: this.CalculateRateForGroup(payload, state.DataHelper.Settings.RateChangeTypeForBGroup, state.DataHelper.Settings.RateChangeForBGroup)
            }, 
            {
                RateGroup: ERating.C, 
                RateValue: this.CalculateRateForGroup(payload, state.DataHelper.Settings.RateChangeTypeForCGroup, state.DataHelper.Settings.RateChangeForCGroup)
            },
            {
                RateGroup: ERating.Outsiders, 
                RateValue: 0
            }
        ];

        return newState;
    }

    private CalculateRateForGroup(rate: number, rateChangeType: ERateChangeType, rateChangeValue: number): number {
        if (rateChangeType === ERateChangeType.Percent) {
            return (rateChangeValue || 0) * rate / 100 + rate;
        } else {
            return (rateChangeValue || 0) + rate;
        }
    }
}
